import { ExperimentType } from 'ha/modules/Experiments';

const Experiments: { [name: string]: ExperimentType } = {
  HA3710: {
    name: '[HA-3710] Search image processing',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  HA3873: {
    name: '[HA-3873] Search algorithm',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
};

export default Experiments;
